import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { KeywordGroupService, KeywordGroupServiceImpl } from './service/keyword-group.service';

export const keywordGroupModule = (bind: interfaces.Bind) => {
    bind(KeywordGroupService).to(KeywordGroupServiceImpl).inRequestScope();
};
